import React from 'react';
import { Row, Col, FormGroup, Card } from 'react-bootstrap';
import { set, isEmpty, get } from 'lodash';
import { useSelector } from 'react-redux';
import { usePurchaseOrderState } from '../PurchaseOrderContext';
import { ElementTemplate } from '../TemplateComponent';
import { commonPath } from '../fieldPath';

export function RenderShippingDetails({ data, pIndex }) {
  const {
    UserDetails: { isSupplierLoggedIn },
    BOMConfigDetails: { productDetails },
  } = useSelector((reduxState) => reduxState);
  const { setPurchaseOrderState, purchaseOrderState, disableConditions, fromPreview, isPublicPoPage, poAddEditAccess } = usePurchaseOrderState();

  const handleChange = async (value, keyName) => {
    const copyState = purchaseOrderState;
    let locate = '';
    if (keyName.includes('options')) {
      locate = keyName.split('.options');
    } else {
      locate = keyName.split('.value');
    }
    if (get(copyState, locate[0]).id === '12') {
      if (value === 'Yes' && get(copyState, `templateJsonSchema[${pIndex}].columns[1][1].value`)) {
        set(copyState, `templateJsonSchema[${pIndex}].columns[1][1].value`, '');
        delete copyState[`templateJsonSchema[${pIndex}].columns[1][1].value`];
      }
      await set(copyState, 'costIncluded', value);
    }
    if (locate[0]?.startsWith(`templateJsonSchema[${pIndex}].columns[1][1]`)) {
      await set(copyState, 'shippingCost', value);
    }
    await set(copyState, keyName, value);
    await setPurchaseOrderState((prevState) => ({
      ...prevState,
      ...copyState,
    }));
  };

  const conditionForCoasting = (array) => {
    let returnValue = false;
    array.forEach((e) => {
      if (e.id === '12' && e.value === 'No') {
        returnValue = true;
      }
    });
    return returnValue;
  };

  return (
    <Card className="listing-card">
      <Card.Header className="px-2 py-2">
        <strong>{data?.label}</strong>
      </Card.Header>
      <Card.Body className="py-4">
        <Row className="span_font_size">
          {data?.columns.map((column, index) => {
            const arr = column.filter((col) => col?.enable === true);
            return (
              !isEmpty(arr) && (
                <Col lg={6}>
                  {column.map((col, i) => {
                    return (
                      col?.enable &&
                      ((col?.id !== '13' && col?.id !== '14') || (col?.id === '13' && conditionForCoasting(data?.columns[0]))) && (
                        <FormGroup>
                          <ElementTemplate
                            {...col}
                            keys={col?.key}
                            disable
                            options={col?.options}
                            placeHolder={col?.label}
                            value={col?.value || null}
                            onChange={handleChange}
                            isProductArchived={productDetails?.isArchived}
                            path={
                              col?.key === 'Check_Boxes' ? commonPath(pIndex, index, i).COMPANY_DETAILS_CHECKBOX : commonPath(pIndex, index, i).COMPANY_DETAILS
                            }
                          />
                        </FormGroup>
                      )
                    );
                  })}
                </Col>
              )
            );
          })}
        </Row>
      </Card.Body>
    </Card>
  );
}

export default RenderShippingDetails;
